import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  container: {
    paddingVertical: 15,
  },
  title: {
    marginTop: 20,
    marginBottom: 5,
  },
  description: {
    width: '70%',
  },
});
